import { api } from './api';

export type ConnectorKind = 'freee' | 'moneyforward' | 'quickbooks' | 'xero' | 'netsuite' | 'salesforce';

export interface ConnectorDescriptor {
  kind: ConnectorKind;
  label: string;
  region: 'JP' | 'global';
  partnerUrl: string;
}

export interface SyncResult {
  inserted: number;
  meta: Record<string, unknown>;
  periodRange: { start: string; end: string };
}

export const connectorsApi = {
  async list(): Promise<ConnectorDescriptor[]> {
    const r = await api.get<ConnectorDescriptor[]>('/api/connectors');
    return r.data;
  },
  startUrl(kind: ConnectorKind, workspaceId: string): string {
    const base = (import.meta.env.VITE_API_URL as string | undefined) || '';
    return `${base}/api/connectors/${kind}/oauth/start?workspaceId=${encodeURIComponent(workspaceId)}`;
  },
  async sync(dataSourceId: string, periodStart: string, periodEnd: string): Promise<SyncResult> {
    const r = await api.post<SyncResult>(`/api/connectors/${dataSourceId}/sync`, { periodStart, periodEnd });
    return r.data;
  },
};
